// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// const conf =require('../../config.json');
import * as conf from '../../config.json';


export const environment = {
  production: false,
  
  apiUrl:conf["test"]['apiUrl'],
  apiUrlSecurity: conf["test"]['apiUrl'],
  wsUrl: conf["test"]['wsUrl'],
  processEnv: 'dev',
  nombreEmpresa: "INVERSIONES AUGAJO S. DE R.L."

};



